export interface TournamentConfigFieldConfig {
  matchDuration?: {
    min?: number;
    max?: number;
    default?: number;
    step?: number;
  };
  signupDeadline?: {
    minDaysFromNow?: number;
  };
  minSchedulesRequired?: {
    min?: number;
    max?: number;
    default?: number;
  };
}

export const DEFAULT_TOURNAMENT_CONFIG_FIELD_CONFIG: TournamentConfigFieldConfig =
  {
    matchDuration: {
      min: 30,
      max: 120,
      default: 60,
      step: 15,
    },
    signupDeadline: {
      minDaysFromNow: 1,
    },
    minSchedulesRequired: {
      min: 1,
      max: 50,
      default: 1,
    },
  };
